import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./recentItemOption.html";
import { i18nStore, selectSharedLabels, WireI18n } from '~/modules/stores/i18nStore';
import { generateMediaUrl } from '~/modules/utilities/asset_utils';
class RecentItemOption extends LightningElement {
  constructor(...args) {
    super(...args);
    this.recentItem = void 0;
    this.shouldShowDefaultLogo = false;
    this.sharedLabels = void 0;
  }
  get logo() {
    // @ts-expect-error * Automated Type Error Fix
    const logoSet = this.recentItem.listing['listing/plugins/LogoSet'];
    return generateMediaUrl(logoSet?.Logo);
  }
  get logoAlt() {
    return this.recentItem?.listing?.name ? i18nStore.getState().i18n.shared.logoAlt({
      LOGO_NAME: this.recentItem.listing.name
    }) : this.sharedLabels.deafultLogoAlt;
  }
  showDefaultLogo() {
    this.shouldShowDefaultLogo = true;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(RecentItemOption, {
  publicProps: {
    recentItem: {
      config: 0
    }
  },
  wire: {
    sharedLabels: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: selectSharedLabels
        };
      }
    }
  },
  fields: ["shouldShowDefaultLogo"]
});
const __lwc_component_class_internal = _registerComponent(RecentItemOption, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;